import React from "react";

const GlobalContext = React.createContext({
  monthIndex: 0,
  setMonthIndex: (index) => {},
  smallCalendarMonth: 0,
  setSmallCalendarMonth: (index) => {},
  daySelected: null,
  setDaySelected: (day) => {},
  showEventModal: false,
  setShowEventModal: () => {},
  dispatchCalEvent: ({ type, payload }) => {},
  savedEvents: [],
  selectedEvent: null,
  setSelectedEvent: () => {},
  setLabels: () => {},
  labels: [],
  updateLabel: () => {},
  cacheLabelsForCalendar: () => {},
  getCachedLabelsForCalendar: () => {},
  clearLabelCache: () => {},
  filteredEvents: [],
  activeCalendarId: null,
  setActiveCalendarId: () => {},
  currentUser: null,
  userLoading: false,
  isReadonly: false,
});

export default GlobalContext;
